import { Switch } from '../ui/switch';

export default function TableHeader({
  children,
  headerTitle,
  headerTitleClass,
  headerDescription = null,
  headerIcon = null,
  headerSwitch = null,
  headerSwitchCase = null,
  headerSwitchHandler = () => {},
  showSwitchIcon = true,
  showSwitchBackground = true,
  showBottomBorder = true,
}) {
  return (
    <div className="relative flex flex-col">
      <div className="h-[6px] bg-[var(--q3-neutral-default)] rounded-t-xl"></div>
      <div
        className={`
          flex flex-col gap-2 md:gap-0 md:flex-row justify-between text-[var(--q3-neutral-default)] text-lg font-bold p-4
          border border-t-0 border-[var(--q3-stroke-light)] rounded-none
          ${!showBottomBorder ? 'border-b-0' : ''}
          ${headerTitleClass}
        `}
      >
        <div className="flex flex-row items-center gap-3">
          {headerIcon && headerIcon}
          <div className="flex flex-col text-wrap justify-center">
            <p>{headerTitle}</p>
            {headerDescription && (
              <p className="text-xs font-normal text-[var(--q3-neutral-light)]">{headerDescription}</p>
            )}
          </div>
        </div>

        {headerSwitch && (
          <div
            className={`
              flex flex-row gap-3 h-9 items-center w-fit text-sm font-medium text-[var(--q3-neutral-default)]
              rounded-xl px-3 whitespace-nowrap
              ${showSwitchBackground ? 'bg-[var(--q3-surface-dim)]' : ''}
            `}
          >
            {headerSwitch}
            {showSwitchIcon && (
              <Switch checked={headerSwitchCase} onCheckedChange={headerSwitchHandler} />
            )}
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
